import { ChevronDown } from "lucide-react";
import type { ReactNode } from "react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { cn } from "@/lib/utils";

import type { Flag } from "./api";
import { flagTone } from "./format";

export function FlagBadge({ flag }: { flag: Flag | string }) {
  const tone = flagTone(flag as Flag);
  return (
    <Badge
      variant="outline"
      className={cn(
        tone === "danger" && "border-ks-danger text-ks-danger",
        tone === "warn" && "border-ks-accent text-ks-ink",
        tone === "purple" && "border-ks-purple-2 text-ks-purple",
        tone === "ok" && "border-ks-purple-3 text-ks-ink",
        tone === "neutral" && "border-ks-grey-3 text-ks-grey-1",
      )}
    >
      {flag}
    </Badge>
  );
}

export function Disclosure({ title, children, defaultOpen = false, open, onOpenChange }: { title: string; children: ReactNode; defaultOpen?: boolean; open?: boolean; onOpenChange?: (open: boolean) => void }) {
  return (
    <Collapsible defaultOpen={defaultOpen} open={open} onOpenChange={onOpenChange} className="rounded-ks-sm border border-ks-grey-4 p-3">
      <CollapsibleTrigger asChild>
        <Button variant="ghost" data-nonmutating className="w-full justify-between">
          {title}<ChevronDown aria-hidden className="size-4" />
        </Button>
      </CollapsibleTrigger>
      <CollapsibleContent className="pt-3">{children}</CollapsibleContent>
    </Collapsible>
  );
}
